























































































import { namespace } from 'vuex-class';
import { Vue, Component, Prop } from 'vue-property-decorator';

import Pix from './components/Pix/Pix.vue';
import BankSlip from './components/BankSlip/BankSlip.vue';
import CreditCard from './components/CreditCard/CreditCard.vue';
import WireTransfer from './components/WireTransfer/WireTransfer.vue';
import EmpiricusRewards from './components/EmpiricusRewards/EmpiricusRewards.vue';

import Alert from '@/shared/components/Alert/Alert.vue';
import Button from '@/shared/components/Button/Button.vue';
import Divider from '@/shared/components/Divider/Divider.vue';
import ButtonBack from '@/shared/components/Button/ButtonBack.vue';
import EarlyRenewal from '@/shared/components/EarlyRenewal/EarlyRenewal.vue';
import ReCAPTCHABranding from '@/shared/components/ReCAPTCHABranding/ReCAPTCHABranding.vue';
import ScreenSizeVisibility from '@/shared/components/ScreenSizeVisibility/ScreenSizeVisibility.vue';

import { EPaymentMethod, ECardStep, EPaymentMethodTypes } from '@/helpers/enums';
import { EBankSlipInstallmentSteps } from '@/shared/enums/EBankSlipInstallmentSteps';

import {
  ICheckout,
  ICheckoutCartOffer,
} from '@/interfaces/Checkout';
import { IPayment } from '@/interfaces/Payment';

import { Payment } from '@/classes/Checkout/Payment';

const AppModule = namespace('App');
const CheckoutModule = namespace('App/Checkout');
const BehaviorModule = namespace('App/Behavior');

@Component({
  components: {
    Alert,
    Button,
    Divider,
    ButtonBack,
    EarlyRenewal,
    ReCAPTCHABranding,
    ScreenSizeVisibility,
    Pix,
    BankSlip,
    CreditCard,
    WireTransfer,
    EmpiricusRewards,
  },
})
export default class PaymentTypes extends Vue {
  public $refs!: {
    'pix': Pix,
    'bankSlip': BankSlip,
    'creditCard': CreditCard,
    'wireTransfer': WireTransfer,
    'empiricusRewards': EmpiricusRewards,
  };

  private auxType: any = EPaymentMethodTypes.creditCard;

  @Prop()
  private readonly isUpsell!: boolean;

  @Prop()
  private readonly isAddressRequired!: boolean;

  @Prop()
  private readonly validateDeliveryAddress!: Function;

  @AppModule.Action
  private prepareCheckout: Function;

  @AppModule.Mutation
  private setCardSelected: Function;

  @AppModule.Mutation
  private setCardFirstDigits: Function;

  @AppModule.Mutation
  private setPaymentMethodSelected: Function;

  @AppModule.State
  private cardFirstDigitsSelected: string | number | null;

  @CheckoutModule.Mutation
  private setPaymentConditionId!: Function;

  @CheckoutModule.Getter
  private rootOffer: ICheckoutCartOffer;

  @CheckoutModule.Getter('selectedOffer')
  private offer!: ICheckoutCartOffer;

  @CheckoutModule.Getter('selectedOfferPayment')
  private payment!: Payment;

  @CheckoutModule.Getter('selectedFilterCreditCard')
  private filterCreditCardSelected!: string | null;

  @CheckoutModule.Getter('selectedRefCreditCardFormActived')
  private refCreditCardSelected!: string | null;

  @CheckoutModule.Getter
  private getOfferPaymentConditionIdByMethodCode!: any;

  @CheckoutModule.State(state => state.checkout)
  private checkout!: ICheckout;

  @CheckoutModule.Action
  private selectOfferPaymentMethodType!: (options: { offer_id?: number, type: EPaymentMethodTypes })=> IPayment;

  @CheckoutModule.Mutation
  protected toggleModalPayment!: Function;

  @CheckoutModule.Mutation('selectOfferPaymentCardStep')
  private selectOfferPaymentCardStep!: (options: { offer_id?: number, step: ECardStep })=> IPayment;

  @CheckoutModule.Mutation
  private readonly setKoinOptinChecked!: Function;

  @CheckoutModule.Mutation
  private readonly setBankSlipInstallmentsStep!: Function;

  @CheckoutModule.Mutation
  private readonly setKoinStepsActivated!: Function;

  @CheckoutModule.Mutation
  private setFilterCreditCard: Function;

  @CheckoutModule.Getter
  private isRenewal!: boolean;

  @CheckoutModule.State
  private enableHiddenMethods: boolean;

  @BehaviorModule.Getter
  private isCaptchaValid: boolean;

  @BehaviorModule.State
  private canPay: boolean;

  @CheckoutModule.Getter('selectedOfferPaymentCardSelected')
  private selectedPaymentCard: any;

  private async getBinDiscountByCardSelected(type: EPaymentMethodTypes) {
    let payload = {};
    let slug = this.rootOffer.slug;

    if (this.$route.name === 'renew') {
      slug = this.$route.params.slug;
    }

    if (this.isUpsell) {
      this.updateUpsell({
        payment_method: type,
        ...(type === EPaymentMethodTypes.creditCard && this.selectedPaymentCard && this.cardFirstDigitsSelected && {
          card_first_digits: this.cardFirstDigitsSelected,
        }),
        ...(this.enableHiddenMethods) && {
          enableHiddenPaymentMethods: this.enableHiddenMethods,
        },
      });
    } else {
      payload = {
        slug,
        payload: {
          payment_method: type,
          ...(type === EPaymentMethodTypes.creditCard && this.selectedPaymentCard && this.cardFirstDigitsSelected && {
            card_first_digits: this.cardFirstDigitsSelected,
          }),
        },
        ...(this.enableHiddenMethods) && {
          enableHiddenMethods: this.enableHiddenMethods,
        }
      };
    }

    await this.prepareCheckout(payload);
  }

  private async prepareBankSlipInstallments(payload: any) {
    let slug = this.rootOffer.slug;

    if (this.$route.name === 'renew') {
      slug = this.$route.params.slug;
    }

    if (this.isUpsell) {
      this.updateUpsell({
        ...(payload.paymentMethod === EPaymentMethodTypes.bankSlip && {
          ...payload,
        }),
      });
    } else {
      payload = {
        slug,
        payload: {
          ...(payload.payment_method === EPaymentMethodTypes.bankSlip && {
            ...payload,
          }),
        },
      };
    }


    await this.prepareCheckout(payload);
  }

  private choosePaymentMethodType (type: EPaymentMethodTypes) {
    let aux = this.auxType;

    this.selectOfferPaymentMethodType({
      offer_id: this.offer.id,
      type,
    });

    this.setPaymentMethodSelected(type);

    if (aux !== type) {
      this.setFilterCreditCard(null);
      this.setOfferPaymentConditionId(EPaymentMethod[type]);
      this.getBinDiscountByCardSelected(type);
      this.resetBankSlipInstallments();
    }

    this.auxType = type;
  }

  private setOfferPaymentConditionId(type: any) {
    const offerPaymentConditionId = this.getOfferPaymentConditionIdByMethodCode(type);

    this.setPaymentConditionId(offerPaymentConditionId);
  }

  private choosePaymentCardStep (step: ECardStep) {
    this.selectOfferPaymentCardStep({
      offer_id: this.offer.id,
      step,
    });
  }

  private resetBankSlipInstallments() {
    this.setKoinStepsActivated(false);
    this.setKoinOptinChecked(false);
    this.setBankSlipInstallmentsStep(EBankSlipInstallmentSteps.initial);
  }

  private paymentTypeIsActive (paymentType: EPaymentMethodTypes) {
    return this.payment.selectedPaymentType === paymentType;
  }

  public paymentTypeIsAvailable (paymentType: EPaymentMethodTypes) {
    return this.payment.paymentTypeIsAvailable(paymentType);
  }

  public updateUpsell(payload: any) {
    this.$emit('updateUpsell', payload);
  }

  public async validatePaymentType (options: { type: 'creditCard' | 'bankSlip' | 'wireTransfer' | 'empiricusRewards' | 'pix', step: ECardStep }) {
    let $paymentType: any = this.$refs[options.type];

    let canSubmit = true;

    if (options.type === EPaymentMethodTypes.creditCard && $paymentType.$refs) {
      $paymentType = $paymentType.$refs[`${this.refCreditCardSelected}`];
    }

    if ($paymentType.validateForm) {
      try {
        const result = await $paymentType.validateForm();

        canSubmit = (result !== undefined)? result : true;
      } catch (error) {
        canSubmit = false;
      }
    }

    if (this.isAddressRequired) {
      try {
        await this.validateDeliveryAddress();
      } catch (_) {
        canSubmit = false;
      }
    }

    return canSubmit;
  }

  private get isMobile () {
    return this.$vuetify.breakpoint.smAndDown;
  }

  private get hasCards (): boolean {
    return this.payment.cards.options.length > 0;
  }

  private get paymentCardSteps () {
    return ECardStep;
  }

  private get paymentMethodTypes(): any {
    return EPaymentMethodTypes;
  }

  private get paymentMethodCardStep () {
    return this.payment.getPaymentMethod(EPaymentMethod.creditCard).step;
  }
}
